import { FEActionResourceType } from "../../../constants/resourceTypes";
import { Node } from "../../../types";
import { SourceHandle } from "../../../types/edges";

type NodeConnectionButtons = Record<
  FEActionResourceType,
  { sourceHandle: SourceHandle; label?: string }[]
>;

const nodesConnectionButtons: NodeConnectionButtons = {
  provider: [
    {
      sourceHandle: "SUCCESSFUL",
    },
    {
      sourceHandle: "FAILED",
    },
  ],
  smartRecurringSetupCit: [
    {
      sourceHandle: "SUCCESSFUL",
    },
    {
      sourceHandle: "FAILED",
    },
  ],
  smartRecurringProcessingMit: [
    {
      sourceHandle: "SUCCESSFUL",
    },
    {
      sourceHandle: "FAILED",
    },
  ],
  autoRecovery: [
    {
      sourceHandle: "SUCCESSFUL",
    },
    {
      sourceHandle: "FAILED",
    },
  ],
  fraudDetection: [
    {
      sourceHandle: "APPROVED",
    },
    {
      sourceHandle: "DECLINED",
    },
    {
      sourceHandle: "NOT_REVIEWED",
    },
    {
      sourceHandle: "ELSE",
    },
  ],
  deviceCheck: [
    {
      sourceHandle: "PASSED",
    },
    {
      sourceHandle: "FAILED",
    },
    {
      sourceHandle: "ELSE",
    },
  ],
  close: [{ sourceHandle: "SUCCESSFUL" }],
  block: [{ sourceHandle: "SUCCESSFUL" }],
  holdAndWait: [],
  delay: [{ sourceHandle: "SUCCESSFUL" }],
  transition: [{ sourceHandle: "SUCCESSFUL" }],
  webhook: [{ sourceHandle: "SUCCESSFUL" }],
  refund: [{ sourceHandle: "TEMP" }],
  recovery: [{ sourceHandle: "TEMP" }],
  capture: [
    {
      sourceHandle: "SUCCESSFUL",
    },
    {
      sourceHandle: "FAILED",
    },
  ],
  void: [
    {
      sourceHandle: "SUCCESSFUL",
    },
    {
      sourceHandle: "FAILED",
    },
  ],
  redirect: [{ sourceHandle: "TEMP" }],
  branch: [],
  jump: [],
  defaultSettings: [
    {
      sourceHandle: "SUCCESSFUL",
    },
    {
      sourceHandle: "FAILED",
    },
  ],
};

export const getNodeConnectionButtons = (node: Node) => {
  const resourceType = node.data?.appliedAction
    .resourceType as FEActionResourceType;

  if (resourceType === "branch") {
    const branchesList = Object.values(
      node.data?.appliedAction?.data ?? {}
    ) as { id: string }[];
    return branchesList
      .map((branch) => ({
        sourceHandle: branch.id,
      }))
      .concat({ sourceHandle: "ELSE" });
  }

  if (resourceType === "holdAndWait") {
    const branchesList = Object.values(
      node.data?.appliedAction?.data ?? {}
    ) as { id: string }[];
    return branchesList
      .map((branch) => ({
        sourceHandle: branch.id,
      }))
      .concat({ sourceHandle: "ELSE" });
  }

  return nodesConnectionButtons[resourceType] || [];
};

export const isSingleConnectionNode = (resourceType: FEActionResourceType) => {
  const connections = nodesConnectionButtons[resourceType];
  if (connections.length === 1) return true;
  return false;
};

export const getAddStepButtonConfig = (
  resourceType: FEActionResourceType
): {
  sourceHandle: SourceHandle;
  show: boolean;
  invisible?: boolean;
} => {
  const connections = nodesConnectionButtons[resourceType];
  if (
    connections.length > 1 ||
    ["branch", "holdAndWait", "jump"].includes(resourceType)
  ) {
    return {
      sourceHandle: "AUTOMATION",
      show: true,
      invisible: true,
    };
  }

  const connection = connections[0];
  return connection.sourceHandle === "TEMP"
    ? { sourceHandle: "AUTOMATION", show: true }
    : { sourceHandle: connection.sourceHandle, show: true };
};
